<lt-navigation></lt-navigation>

<div class="content">
  <div class="header-image" aria-hidden="true"></div>
  <router-outlet></router-outlet>
</div>
